import React from 'react';

const DiscountTag = ({ message, className = '', textColor, bgColor }) => {
  const styles = {};

  if (textColor) {
    styles.color = textColor;
  }

  if (bgColor) {
    styles.backgroundColor = bgColor;
  }

  return (
    <div
      style={styles}
      className={`caption rounded-md px-2 py-0.5 ${className}`}
    >
      <span>{message}</span>
    </div>
  );
};

export default DiscountTag;
